import _ from 'lodash';
import UniversalRouter from 'universal-router';
import routes from './routes';

export default new UniversalRouter(routes, {
  resolveRoute(context, params) {
    if (context.route.protected && context.isAuthenticated === false) {
      return { redirect: '/login', from: context.pathname };
    }

    if (
      (context.pathname === '' || context.pathname === '/') &&
      context.userType >= 20 &&
      context.userType < 30
    ) {
      return { redirect: '/jointhousinggroups', from: context.pathname };
    }

    if (
      (context.pathname === '' || context.pathname === '/') &&
      context.userType >= 30 &&
      context.userType < 40
    ) {
      return { redirect: '/jointhousinggroups', from: context.pathname };
    }

    if (context.pathname === '/setnotificationuser' && context.userType < 40) {
      return { redirect: '/setnotification', from: context.pathname };
    }

    if (context.pathname === '/setnotification' && context.userType >= 40) {
      return { redirect: '/setnotificationuser', from: context.pathname };
    }

    if (context.route.params) {
      params = _.defaults(context.route.params, params);
    }
    if (typeof context.route.redirect === 'function') {
      return context.route.redirect();
    }
    if (typeof context.route.load === 'function') {
      return context.route
        .load()
        .then(action => action.default(context, params));
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return undefined;
  },
});
